var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventDataFlow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_3",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.000488281H0V24.0005H24V0.000488281Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2308 19.7698H20.6154V18.2314H22.4615V5.71853H20.6667V4.18007H23.2308C23.6556 4.18007 24 4.50315 24 4.92797V18.9858C24 19.4106 23.6556 19.7698 23.2308 19.7698ZM9.02564 4.18007H10.3077V5.71853H9.02564V4.18007ZM8.05128 7.56469C8.05128 7.98951 7.70687 8.33392 7.28205 8.33392H0.769231C0.34441 8.33392 0 7.98951 0 7.56469V2.3852C0 1.96038 0.34441 1.61597 0.769231 1.61597H7.28205C7.70687 1.61597 8.05128 1.96038 8.05128 2.3852V7.56469ZM1.53846 6.79545H6.51282V3.15443H1.53846V6.79545ZM19.3846 16.4365C19.3846 16.0117 19.0402 15.6672 18.6154 15.6672H12.1026C11.6777 15.6672 11.3333 16.0117 11.3333 16.4365V21.616C11.3333 22.0408 11.6777 22.3852 12.1026 22.3852H18.6154C19.0402 22.3852 19.3846 22.0408 19.3846 21.616V16.4365ZM19.3846 2.43648C19.3846 2.01166 19.0402 1.66725 18.6154 1.66725H12.1026C11.6777 1.66725 11.3333 2.01166 11.3333 2.43648V7.61597C11.3333 8.04079 11.6777 8.3852 12.1026 8.3852H18.6154C19.0402 8.3852 19.3846 8.04079 19.3846 7.61597V2.43648Z",
    fill: "#111928"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDataFlow);
export default __webpack_public_path__ + "static/media/event-data-flow.bffacbdcad9fc4feb43551e2f832a5dd.svg";
export { ForwardRef as ReactComponent };